var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoteList',{attrs:{"delete-permission":'delete_inventoryitem',"change-permission":'change_inventoryitem',"object-uuid":_vm.inventory.uuid,"plural-object-name":"inventories","object-name":"inventory","is-loading-text":false}})}
var staticRenderFns = []

export { render, staticRenderFns }